export default __webpack_public_path__ + "static/media/Ballroll_00163.838e13cb.png";